export default __webpack_public_path__ + "static/media/Wenzel.aed1b78d.png";